import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import { QueryKey } from '../utils/api';
import { sfccGet } from '../utils/sitegenesis';
import { isServer } from '../utils/utils';
import { StorageKey } from './model/StorageKey';
import { CookieStorage } from './useCookieStorage';
import type { UserAddress } from './model/UserAddress';

export const useUserAddress = (): UseQueryResult<UserAddress, unknown> =>
    useQuery<unknown, unknown, UserAddress>({
        queryFn: async () => {
            const options = { expires: 7 };
            const storage = new CookieStorage();
            const userAddressCookie = storage.get(StorageKey.USER_ADDRESS);

            if (userAddressCookie) {
                const userAddress = JSON.parse(userAddressCookie) as UserAddress;

                // Set again to renew the expiration date.
                storage.set(StorageKey.USER_ADDRESS, userAddressCookie, options);

                return userAddress;
            }

            const userAddress = await sfccGet<UserAddress>('GoLocal-IpLocation');

            storage.set(StorageKey.USER_ADDRESS, JSON.stringify(userAddress), options);

            return userAddress;
        },
        queryKey: [QueryKey.USER_ADDRESS],
        enabled: !isServer,
    });
